import { ModalContainerPAK } from "./Modal/ModalContainerPAK";
import { ModalContainerTGO } from "./Modal/ModalContainerTGO";
import { ModalContainerWarningRemovePhotoCheckList } from "./Modal/ModalContainerWarningRemovePhotoCheckList";
import { ModalContainerWarningRemovePhoto } from "./Modal/ModalContainerWarningRemovePhoto";
import { getDirection } from "./FlightBlock/ChecklistBlock";
import { loader } from '@/components/Loader.js';
import { flightSchedule } from "./Pages/FlightSchedulePage";
import { FlightService } from "./Pages/FlightServicesPage";
import { ModalContainerAudioRecord } from "./Modal/ModalContainerAudioRecord";
import SignaturePad from "signature_pad";
import { storage } from "@/components/Storage";

export  function closeAudioRecord() {
    let timerId = localStorage.getItem("audioTimerId");
    timerId !== 'underfined' ? timerId : 0;
    if(timerId) {
        clearInterval(timerId);
        localStorage.removeItem("audioTimerId");
        if(document.getElementById("audioTimer"))
            document.getElementById("audioTimer").innerHTML = "00:00";
        if(ModalContainerAudioRecord.container)
            ModalContainerAudioRecord.container.hidden = true;
    }
    let event = new Event("breakAudioRecord", {bubbles: true});
    document.dispatchEvent(event);
}

export function loadAudioRecords(arrAudio) {
    var audioRecords = document.getElementById("audioRecords");
    if(audioRecords) {
        arrAudio.forEach(function (item) {
            let audioRecords = document.getElementById("audioRecords");
            let audio = document.createElement("audio");
            audio.src = item.base64;
            audio.setAttribute("name", item.fileName);
            audio.onended = function () {
                let i = button_play.getElementsByTagName("icon")[0];
                if (i.classList.contains("fa-pause")) {
                    audio.pause();
                    i.classList.remove("fa-pause");
                    i.classList.add("fa-play");
                }
            }
            audioRecords.append(audio);
        })
    }
}

export function filterTableWork() {
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("inputWorkName");
    filter = input.value.toUpperCase();
    ul = document.getElementById("tableTask");
    li = ul.getElementsByTagName("tr");
    for (i = 0; i < li.length; i++) {
        if(li[i].getElementsByTagName("span").length > 0) {
            a = li[i].getElementsByTagName("span")[0];
            txtValue = a.textContent || a.innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                li[i].style.display = "";
            } else {
                li[i].style.display = "none";
            }
        }
    }
}

export function isCanvasBlank(canvas) {
    const blank = document.createElement('canvas');

    blank.width = canvas.width;
    blank.height = canvas.height;

    var signaturePad = new SignaturePad(blank, {
        backgroundColor: 'rgb(255, 255, 255)'
    });
    signaturePad.clear();

    return canvas.toDataURL() === blank.toDataURL();
}

export function render_sign() {
    //var canvas = document.querySelector("canvas");
    var canvas = document.querySelector("#canvasSignCheckList");
    if (canvas !== null) {
        var signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)'
        });
        var saveButton = document.getElementById('save_sign');
        var cancelButton = document.getElementById('clear_sign');

        if(saveButton != null) {
            saveButton.addEventListener('click', function () {
                if (signaturePad.isEmpty()) {
                    alert("Необходимо подписать карту учета.");
                    return false;
                }
                // Получаем подпись
                var signature = signaturePad.toDataURL('image/png');
                // Фильтруем, только установленные значения
                var service_list = FlightService.list.filter(function (service) {
                    return service.value;
                }).map(function (service) {
                    return service.value ? {
                        Name: service.title,
                        Code: service.code,
                        Value: service.value,
                        Measure: service.measureUnit,
                        Note: ''
                    } : false;
                });
                // Сохраняем карту учета с подписью ПАК
                m.request({
                    method: 'PUT',
                    url: '/api/service_list_sign',
                    data: {
                        id_spp: storage.id_spp,
                        id_skill: storage.id_skill,
                        service_list: service_list,
                        signature: signature
                    }
                }).then(function (response) {
                    if (response.data) {
                        alert('Карта учета сохранена');
                        ModalContainerPAK.close();
                    } else {
                        alert(response.message);
                    }
                }).catch(function (response) {
                    console.log(response);
                    alert('Ошибка сохранения. Обратитесь к разработчику.');
                })
            });
        }

        cancelButton.addEventListener('click', function () {
            signaturePad.clear();
        });
    }
}

export function render_tgo_sign(){
    //var canvas = document.querySelector("canvas");
    var canvas = document.getElementById("canvasSignTGO");
    if (canvas !== null) {

        //var signaturePad = document.getElementById("canvasSignTGO");
        var signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgb(255, 255, 255)'
        });
        var saveButton = document.getElementById('save_sign');
        var cancelButton = document.getElementById('clear_sign');

        if(saveButton != null) {
            saveButton.addEventListener('click', function () {
                if (signaturePad.isEmpty()) {
                    alert("Необходимо подписать Технологическую карту.");
                    return false;
                }
                // Получаем подпись
                const signature = signaturePad.toDataURL('image/png');
                // Фильтруем, только установленные значения
                const operation_list = flightSchedule.currentList.filter(x => x.factBeginTime !== null && !x.isCancelled)
                    .map(function (item) {
                        return {
                            serviceId: item.serviceId,
                            title: item.title,
                            factBeginTime: item.factBeginTime,
                            factFinishTime: item.factFinishTime,
                            isMilestone: item.isMilestone,
                            comment: item.comment,
                            type: item.type,
                        };
                    });

                // Сохраняем карту учета с подписью ПАК
                m.request({
                    method: 'PUT',
                    url: '/api/operation_list_sign',
                    data: {
                        id_spp: flightSchedule.currentTask.flightId,
                        id_graph: flightSchedule.schedules.find(x => Number(x.number) === Number(flightSchedule.currentSchedule)).graphId, // FlightSchedule.scheduleNumber,
                        operation_list: operation_list,
                        signature: signature
                    }
                }).then(function (response) {
                    flightSchedule.init(true);
                    alert('Технологическая карта сохранена');
                    ModalContainerTGO.close();
                }).catch(function (response) {
                    console.log(response);
                    alert('Ошибка сохранения. Обратитесь к разработчику.');
                })
            });
        }

        cancelButton.addEventListener('click', function () {
            signaturePad.clear();
        });
    }
}

export function serialize(form) {
    var field, l, s = {};
    if (typeof form == 'object' && form.nodeName == "FORM") {
        var len = form.elements.length;
        for (var i=0; i<len; i++) {
            field = form.elements[i];
            if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
                if (field.type == 'select-multiple') {
                    l = form.elements[i].options.length;
                    var values = [];
                    for (var j=0; j<l; j++) {
                        if (field.options[j].selected)
                            values.push(field.options[j].value);
                    }
                    s[field.name] = values;
                } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                    s[field.name] = field.value;
                }
            }
        }
    }
    return s;
}

export function unixTimeToDate(unix_timestamp) {
    var date = new Date(unix_timestamp);
// Hours part from the timestamp
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDay();

    var hours = date.getHours();
// Minutes part from the timestamp
    var minutes = "0" + date.getMinutes();
// Seconds part from the timestamp
    var seconds = "0" + date.getSeconds();

    var milliseconds = "0" + date.getMilliseconds();

// Will display time in 10:30:23 format
    var formattedTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2) + "." + milliseconds.substr(-2);

    return formattedTime;
}

function convertImgToBase64URL(unsavedPhoto, callback, outputFormat = 'image/jpeg') {
    var img = new Image();
    var newWidth, newHeight;
    img.crossOrigin = 'Anonymous';
    img.onload = function(){
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        var data = [];
        newWidth = 1920;
        newHeight = Math.floor(img.height / img.width * newWidth);
        canvas.height = newHeight; //img.height;
        canvas.width = newWidth; //img.width;
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        data.name = unsavedPhoto.name;
        data.dk = unsavedPhoto.dk;
        data.comment = unsavedPhoto.comment;
        data.base64 = canvas.toDataURL(outputFormat, 0.7);
        callback(data);
        canvas = null;
    };
    img.onerror = function (event) {
        alert("Error");
    };
    img.src = unsavedPhoto.blobUrl;
}

export function convertImgToBase64URLCheckList(unsavedPhoto, callback, outputFormat = 'image/jpeg') {
    var img = new Image();
    var newWidth, newHeight;
    img.crossOrigin = 'Anonymous';
    img.onload = function(){
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        var data = [];
        newWidth = 1920;
        newHeight = Math.floor(img.height / img.width * newWidth);
        canvas.height = newHeight; //img.height;
        canvas.width = newWidth; //img.width;
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        /*        data.name = unsavedPhoto.name;
                data.dk = unsavedPhoto.dk;
                data.comment = unsavedPhoto.comment;*/
        data = canvas.toDataURL(outputFormat, 0.7);
        callback(data);
        canvas = null;
    };
    img.onerror = function (event) {
        alert("Error");
    };
    img.src = unsavedPhoto;
}

export function paintPhotoCheckList(direction = "arrive", readOnly = false) {

    let checkList = localStorage.getItem("checkList");
    if(checkList)
        checkList = JSON.parse(checkList);
    else
        return;

    let photoCheckList;
    if(checkList.photo.length)
        photoCheckList = checkList.photo;
    else
        photoCheckList = [];


    var container = document.getElementById("pictureConteiner");
    var photo;
    if(container != null)
        photo = container.children;
    else {
        photo = null;
        return;
    }
    var arrNames = [];
    for(let i = 0; i < photo.length; i++) {
        arrNames.push(photo[i].id);
    }

    for(let i = 0; i < photoCheckList.length; i++) {
        if(!arrNames.includes(photoCheckList[i].name)) {

            const div = document.createElement('div');
            div.style = "display: flex; flex-direction: column; align-items: center; margin-top: 7px; outline: 1px solid #000;";
            div.id = photoCheckList[i].name;

            const header = document.createElement("div");
            if(direction == "arrive")
                header.className = "row bg-info";
            else
                header.className = "row bg-danger";
            header.style = "padding:6px;padding-right: 11px;z-index:1; width: 100%; min-height: 32px;";

            if(!readOnly) {
                const closeButton = document.createElement("span");
                closeButton.className = "pull-right classReadOnly";
                closeButton.style = "cursor: pointer;";
                closeButton.innerHTML = "<i class='glyphicon glyphicon-remove'>&nbsp;Удалить";
                closeButton.onclick = function () {
                    ModalContainerWarningRemovePhotoCheckList.open("Вы действительно хотите удалить фото?", false, this.parentElement.parentElement.id);
                };
                header.appendChild(closeButton);
            }
            div.appendChild(header);

            const image = document.createElement('img');
            if(photoCheckList[i].blobUrl != "" && photoCheckList[i].blobUrl != undefined)
                image.src = photoCheckList[i].blobUrl;
            else
                image.src = photoCheckList[i].base64Img;
            image.name = photoCheckList[i].name;
            image.className = "col-xs-12 col-sm-6 col-md-4 col-xl img-thumbnail";
            image.onerror = function () {
                removeElementIndexedDBCheckList(photoCheckList[i].dk);
            };
            div.appendChild(image);
            if(container.children.length > 0) {
                let firstChild = container.firstChild;
                container.insertBefore(div, firstChild);
            }
            else
                container.appendChild(div);
        }
    }
}

export function paintPhoto() {

    let unsavedPhoto = localStorage.getItem("unsavedPhoto");
    if (unsavedPhoto)
        unsavedPhoto = JSON.parse(unsavedPhoto);
    else
        unsavedPhoto = [];

    const container = document.getElementById("pictureConteiner");
    let photo;
    if(container != null)
        photo = container.children;
    else {
        photo = null;
        return;
    }
    let arrNames = [];
    for(let i = 0; i < photo.length; i++) {
        arrNames.push(photo[i].id);
    }

    for(let i = 0; i < unsavedPhoto.length; i++) {
        if(!arrNames.includes(unsavedPhoto[i].name)) {

            const div = document.createElement('div');
            div.style = "display: flex; flex-direction: column; align-items: center; margin-top: 7px; outline: 1px solid #000;";
            div.id = unsavedPhoto[i].name;

            const header = document.createElement("div");
            header.className = "row bg-info";
            header.style = "padding:6px;padding-right: 11px;z-index:1; width: 100%;";
            const closeButton = document.createElement("span");
            closeButton.className = "pull-right";
            closeButton.style = "cursor: pointer;";
            closeButton.innerHTML = "<i class='glyphicon glyphicon-remove'>&nbsp;Удалить";
            closeButton.onclick = function () {
                ModalContainerWarningRemovePhoto.open("Вы действительно хотите удалить фото?", false, false, this.parentElement.parentElement.id);
            };
            header.appendChild(closeButton);
            div.appendChild(header);

            const image = document.createElement('img');
            image.src = unsavedPhoto[i].blobUrl;
            image.name = unsavedPhoto[i].name;
            image.className = "col-xs-12 col-sm-6 col-md-4 col-xl img-thumbnail";
            image.onerror = function () {
                removeElementIndexedDB(unsavedPhoto[i].name);
            };
            div.appendChild(image);

            const comment = document.createElement('textarea');

            comment.rows = 3;
            comment.placeholder = "Комментарий";
            comment.value = (unsavedPhoto[i].comment != "") ? unsavedPhoto[i].comment : '';
            comment.style = "margin: 0px 7px; width: 100%;";
            comment.onfocus = function () {
                let el = document.getElementsByClassName("fixButton")["buttonCamera"];
                el.classList.add("disapear");
            };
            comment.onblur = function () {
                let el = document.getElementsByClassName("fixButton")["buttonCamera"];
                el.classList.remove("disapear");
                addCommentPhoto(div.id, this.value);
                // comment.textContent = "hello";
            }
            div.appendChild(comment);

            if(container.children.length > 0) {
                let firstChild = container.firstChild;
                container.insertBefore(div, firstChild);
            }
            else
                container.appendChild(div);
        }
    }
}

export function addCommentPhoto(id, text) {
    let unsavedPhoto = localStorage.getItem("unsavedPhoto");
    if (unsavedPhoto)
        unsavedPhoto = JSON.parse(unsavedPhoto);
    else
        unsavedPhoto = [];


    var arrNames = [];
    for(let i = 0; i < unsavedPhoto.length; i++) {
        if(unsavedPhoto[i].name == id )
            unsavedPhoto[i].comment = text;
    }

    let value = JSON.stringify(unsavedPhoto);
    localStorage.setItem("unsavedPhoto", value);
}

export function removeElementIndexedDB(id) {

    let unsavedPhoto = localStorage.getItem("unsavedPhoto");
    if (unsavedPhoto)
        unsavedPhoto = JSON.parse(unsavedPhoto);
    else
        unsavedPhoto = [];


    var arrNames = [];
    for(let i = 0; i < unsavedPhoto.length; i++) {
        if(unsavedPhoto[i].name != id )
            arrNames.push(unsavedPhoto[i]);
    }

    let value = JSON.stringify(arrNames);
    localStorage.setItem("unsavedPhoto", value);


    document.getElementById(id).remove();

    let children = document.getElementById("pictureConteiner").children;
    if(children.length == 0)
        loader.hide();
}

export function removeElementIndexedDBCheckList(id) {
    let audit = JSON.parse(localStorage.getItem("checkList"));

    var arrNames = [];
    for(let i = 0; i < audit.photo.length; i++) {
        if(audit.photo[i].name != id)
            arrNames.push(audit.photo[i]);
    }
    audit.photo = arrNames;

    let value = JSON.stringify(audit);
    localStorage.setItem("checkList", value);

    document.getElementById(id).remove();

    let children = document.getElementById("pictureConteiner").children;
    if(children.length == 0)
        loader.hide();
}

export function savePAKtoDB() {

    var canvas = document.getElementById("canvasSignPAK");
    var signature;
    if (canvas !== null) {
        // Получаем подпись
        signature = canvas.toDataURL('image/png');
    }
    else {
        alert("Необходимо подписать Карту учета.");
        return false;
    }
    // Фильтруем, только установленные значения
    var service_list = FlightService.list.filter(function (service) {
        return service.value;
    }).map(function (service) {
        return service.value ? {
            Name: service.title,
            Code: service.code,
            Value: service.value,
            Measure: service.measureUnit,
            Note: ''
        } : false;
    });
    // Сохраняем карту учета с подписью ПАК
    loader.show();
    m.request({
        method: 'PUT',
        url: '/api/service_list_sign',
        data: {
            id_spp: storage.id_spp,
            id_skill: storage.id_skill,
            service_list: service_list,
            signature: signature
        }
    }).then(function (response) {
        if (response.data) {
            loader.hide();
            alert('Карта учета сохранена');
            ModalContainerPAK.close();
        } else {
            alert(response.message);
        }
    }).catch(function (response) {
        loader.hide();
        console.log(response);
        alert('Ошибка сохранения. Обратитесь к разработчику.');
    })
}

export function saveTGOtoDB() {

    var canvas = document.getElementById("canvasSignTGO");
    var signature;
    if (canvas !== null) {
        // Получаем подпись
        signature = canvas.toDataURL('image/png');
    }
    else {
        alert("Необходимо подписать Технологическую карту.");
        return false;
    }

    // Фильтруем, только установленные значения
    const operation_list = flightSchedule.currentList.filter(x => x.factBeginTime !== null && !x.isCancelled)
        .map(function (item) {
            return {
                serviceId: item.serviceId,
                title: item.title,
                factBeginTime: item.factBeginTime,
                factFinishTime: item.factFinishTime,
                isMilestone: item.isMilestone,
                comment: item.comment,
                type: item.type,
            };
        });

    loader.show();
    // Сохраняем карту учета с подписью ПАК
    m.request({
        method: 'PUT',
        url: '/api/operation_list_sign',
        data: {
            id_spp: flightSchedule.currentTask.flightId,
            id_graph: flightSchedule.schedules.find(x => Number(x.number) === Number(flightSchedule.currentSchedule)).graphId, // FlightSchedule.scheduleNumber,
            operation_list: operation_list,
            signature: signature
        }
    }).then(function (response) {
        loader.hide();
        flightSchedule.init(true);
        alert('Технологическая карта сохранена');
        ModalContainerTGO.close();
    }).catch(function (response) {
        loader.hide();
        console.log(response);
        alert('Ошибка сохранения. Обратитесь к разработчику.');
    })
   // }

}

export function saveCheckListDB() {

    let checkList = localStorage.getItem("checkList");
    checkList = JSON.parse(checkList);


    var canvas = document.getElementById("canvasSignCheckList");
    var signBase64;
    if (canvas !== null) {
        signBase64 = canvas.toDataURL('image/jpeg', 0.7);
    }
    //////////////////////////////////////////////
    //const image = document.createElement('img');
    //image.src = signBase64;
    //var cont = document.getElementById("pictureConteiner");
    //cont.appendChild(image);
    //////////////////////////////////////////////



    loader.show();
    var PV = getDirection();
    var commentCheckList = document.getElementById("commentCheckList");

    checkList.sign = signBase64;
    checkList.comment = commentCheckList.value;

    checkList = JSON.stringify(checkList);

    m.request({
        method: 'PUT',
        url: '/api/task/' + m.route.param('taskId') + '/saveChecklist',
        data: checkList
    }).then(function (response) {
        loader.hide();

        checkList = JSON.parse(checkList);
        checkList.signDT = response["dateTimeSign"];
        checkList = JSON.stringify(checkList);
        localStorage.setItem("checkList", checkList);

        for(let i = 1; i <= 9; i++) {
            let numb  = i.toString();
            let yes = document.getElementById('checkboxYes'+numb);
            let no = document.getElementById('checkboxNo'+numb);
            let text = document.getElementById("textComment"+numb);

            yes.disabled = "disabled";
            no.disabled = "disabled";
            text.disabled = "disabled";
        }

        document.getElementById('resetAll').disabled = "disabled";
        document.getElementById('buttonCamera').disabled = "disabled";
        document.getElementById('commentCheckList').disabled = "disabled";
        document.getElementById('signAudit').disabled = "disabled";

        let container = document.getElementsByClassName("classReadOnly"); //document.getElementById('pictureConteiner');
        while(container.length) {
            container[0].remove();
        }


    }, function () {
        loader.hide();
    });
}

export function savePhotoDB() {

    let unsavedPhoto = localStorage.getItem("unsavedPhoto");
    if (unsavedPhoto)
        unsavedPhoto = JSON.parse(unsavedPhoto);
    else
        unsavedPhoto = [];

    for(let i = 0; i < unsavedPhoto.length; i++) {
        let photo;
        var base64Photo = "";
        convertImgToBase64URL(unsavedPhoto[i], function(img){
            base64Photo = img;// Base64DataURL
            var now = new Date();
            let photo = { "name": img.name, "dk": now,  "comment": img.comment, "base64Photo": img.base64 };

            loader.show();
            m.request({
                method: 'PUT',
                //url: '/api/' + m.route.param(\'taskId\') + '/savePhoto',
                url: '/api/task/' + m.route.param('taskId') + '/savePhoto',
                data: photo
            }).then(function (response) {
                removeElementIndexedDB(unsavedPhoto[i].name);
            }, function () {
                loader.hide();
            });

        });
    }
}
